import React from 'react';

const CompFmtInput = ({ attrs, onChange, onBlur }) => {
    const {
        id,
        label,
        type = 'text',
        placeholder = '',
        required = '',
        maxLength,
        value = '',
        disabled = false,
        classCol = 'col-12',
        className = 'form-control'
    } = attrs;

    // id에 'date'가 포함되어 있으면 datepicker 타입으로 변경
    const inputType = id && id.toLowerCase().includes('date') ? 'date' : type;

    return (
        <div className={classCol}>
            <label htmlFor={id} className="form-label">
                {label}
            </label>
                <div className="input-group has-validation">
                    {required ? (<span className="input-group-text">*</span>) : (<></>)}
                    <input
                        type={inputType}
                        className={className}
                        style={{paddingRight: '0.2rem'}}
                        id={id}
                        placeholder={placeholder}
                        required={required}
                        maxLength={maxLength}
                        disabled={disabled}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                    {value && !disabled && (
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            onClick={() => {
                                if (onChange) {
                                    const fakeEvent = {
                                        target: {
                                            id: id,
                                            value: ''
                                        }
                                    };
                                    onChange(fakeEvent);
                                }
                            }}
                            title="지우기"
                            style={{
                                padding: '0.375rem 0.75rem',
                                paddingLeft: '0rem',
                                borderLeft: 'none',
                                backgroundColor: '#ffffff',
                                color: '#6c757d',
                                borderColor: '#ced4da'
                            }}
                        >
                            <i className="bi bi-x-lg"></i>
                        </button>
                    )}
                    {required ? (<div className="invalid-feedback"></div>) : (<></>)}
                </div>
        </div>
    );
};

export default CompFmtInput;